import PropTypes from 'prop-types';
import SiteHistory from './components/SiteHistory';
import ReimbursementDue from './components/ReimbursementDue';
import EnergyReimbursement from './components/EnergyReimbursement';
import LandShareUtilisation from './components/LandShareUtilisation';

const LsBs = ({statement}) => {

  const reimbursementDue = statement.data.elecReimbursementDay + statement.data.elecReimbursementNight;
  return (
    <div>
      <SiteHistory siteLiveDate={statement.data.siteLiveDate} liveDaysInQ={statement.data.liveDaysInQ}/>
      <EnergyReimbursement data={statement.data}/>
      <LandShareUtilisation data={statement.data} /> 

      {/* get clarification from leo */}
      <ReimbursementDue reimbursementDue={reimbursementDue}/>
    </div>
  )
}

export default LsBs;

LsBs.propTypes = {
  statement: PropTypes.object.isRequired,
};